import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import loc from '../../utils/loc';
import Button from '../Button';

import { BREAKPOINTS } from '../../settings';

const Cta = ({ text, link, image }) => {
  if(text && link) {
    return (
      <Wrapper>
        {image ? <ImgWrapper><Image src={image} alt="" /></ImgWrapper> : null}
        <Content>
          <Title>{text}</Title>
          <Button as="a" primary={false} href={link}><span className="icon icon--arrow-right " aria-hidden="true"></span> {loc.t('see more')}</Button>
        </Content>
      </Wrapper>
    );
  }

  return null;
}

Cta.propTypes = {
  text: PropTypes.string,
  link: PropTypes.string,
  image: PropTypes.string,
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 40px;
  @media (min-width: ${BREAKPOINTS.sm}) {
    flex-direction: row;
  }
`;

const Content = styled.div`
  order: 1;
  align-self: center;
  @media (min-width: ${BREAKPOINTS.sm}) {
    order: 2;
  }
`;

const ImgWrapper = styled.div`
  align-self: center;
  flex-grow: 1;
  flex-shrink: 0;
  order: 2;
  @media (min-width: ${BREAKPOINTS.sm}) {
    align-self: end;
    order: 1;
  }
`;

const Image = styled.img`
  display: block;
  margin: 0 auto -20px auto; // Pull flush with container bottom edge
`;

const Title = styled.h3`
  font-size: 1rem;
  letter-spacing: 3px;
  margin: 0 0 24px 0;
  @media (min-width: ${BREAKPOINTS.sm}) {
    font-size: 1.2rem;
  }
`;

export default Cta;
